import { Reducer } from 'react';
import { CLEAR_PRIO_CACHE } from '../../../actions';
import { SET_LAST_PROJECT_LOCATION, LastProjectLocation } from '../actions';

const reducer: Reducer<string, LastProjectLocation> = (
  state = null,
  action
) => {
  switch (action.type) {
    case SET_LAST_PROJECT_LOCATION: {
      return action.projectLocation;
    }
    case CLEAR_PRIO_CACHE: {
      return null;
    }
    default:
      return state;
  }
};

export const getLastProjectLocation = (state: string) => state;

export default reducer;